import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DigitalSignageTokenService implements HttpInterceptor {
  private readonly router = inject(Router);

  readonly token = signal<string | null>(null);

  constructor() {
    this.token.set(this.extractToken());
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.token.set(this.extractToken()));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.token();

    if (token == null) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          'digital-signage-token': token,
        },
      })
    );
  }

  private extractToken(): string | null {
    const tree = this.router.parseUrl(this.router.url);
    return tree.queryParamMap.get('digital-signage-token');
  }
}
